export enum FeeType {
  TRANSPORTATION_FEES = 'Transportation Fees',
  EXTRA_KILOMETER_CHARGE = 'Extra Kilometer Charge',
  DEMURRAGE = 'Demurrage',
  FIXED_COSTS = 'Fixed Costs',
  ADDITIONAL_EXPENSES = 'Additional Expenses'
}
